export default "__VITE_ASSET__DC68el8W__"